import {AxiosRequestConfig, AxiosResponse, RawAxiosRequestHeaders} from "axios";
import {IParcelWebHttpClient} from "./IParcelWebHttpClient";

const axios = require('axios');

// todo: for later
// // abstraction to not rely on vendor objects
// export class HttpCallOptions {
//     url: string;
//     method?: string;
//     params?: { [key: string]: string; };
//     data?: any;
//     headers: { [key: string]: string; };
//     // add more as needed
// }
//
//
// export interface HttpResponse {
//     data: any;
//     status: number;
//     headers: { [key: string]: string; };
//     url: string;
//     // add more as needed
// }

export class ParcelWebHttpClient implements IParcelWebHttpClient {


    public async request(options: AxiosRequestConfig): Promise<AxiosResponse<any>> {
        return await axios.request(options);
    }

    public async get(options: AxiosRequestConfig): Promise<AxiosResponse<any>> {
        options.method = "GET";
        return this.request(options);
    }

    public async post(options: AxiosRequestConfig): Promise<AxiosResponse<any>> {
        options.method = "POST";
        return this.request(options);
    }

    public async put(options: AxiosRequestConfig): Promise<AxiosResponse<any>> {
        options.method = "PUT";
        return this.request(options);
    }

    public async patch(options: AxiosRequestConfig): Promise<AxiosResponse<any>> {
        options.method = "PATCH";
        return this.request(options);
    }

    public async delete(options: AxiosRequestConfig): Promise<AxiosResponse<any>> {
        options.method = "DELETE";
        return this.request(options);
    }

}